'use client';

export const SPA_NAV_START_MARK = 'spa-navigation-start';

/**
 * Stamps a performance mark at the moment of SPA navigation intent (link click or popstate).
 * Clears any previous mark so only the most recent navigation is tracked.
 */
export function markSpaNavigationStart(): void {
  performance.clearMarks(SPA_NAV_START_MARK);
  performance.mark(SPA_NAV_START_MARK);
}

/**
 * SPA-aware drop-in replacement for `Math.round(performance.now())`.
 *
 * Returns rounded elapsed milliseconds since the navigation that brought the user to the
 * current page. For SPA navigations, reads the `spa-navigation-start` performance mark
 * stamped at link-click or popstate. For full page loads, no mark exists and
 * `performance.now()` is returned directly — correct because `performance.timeOrigin`
 * was reset by the browser at load time.
 */
export function isSpaNavigation(): boolean {
  return performance.getEntriesByName(SPA_NAV_START_MARK, 'mark').length > 0;
}

export function navPerformanceNow(): number {
  const marks = performance.getEntriesByName(SPA_NAV_START_MARK, 'mark');
  if (marks.length > 0) {
    return Math.round(
      Math.max(0, performance.now() - marks[marks.length - 1].startTime)
    );
  }

  return Math.round(performance.now());
}
